var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import DisplayField from "@/components/fields/displayField";
import { FieldViewType } from "@/components/fields/viewType";
import widgetsDictionary from "@/components/widgets/widgetsDictionary";
import { useLayout } from "@/hooks/layout";
import { useUpdateRecordsMutation } from "@/store/api";
import { Slot } from "@/utils/types/layout";
import { useState, useCallback, useEffect } from "react";
import toast from "react-hot-toast";
export function MassupdateForm(_a) {
    var _this = this;
    var _b, _c, _d, _e, _f, _g;
    var widget = _a.widget;
    var layout = useLayout();
    var moduleName = (_b = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _b === void 0 ? void 0 : _b.module;
    var field_defs = ((_c = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _c === void 0 ? void 0 : _c.massUpdateFields) || [];
    var idsrecord = ((_d = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _d === void 0 ? void 0 : _d.recordId) || [];
    var _h = useState(""), message = _h[0], setMessage = _h[1];
    var onSubmit = (_e = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _e === void 0 ? void 0 : _e.onSubmit;
    var isLoading = (_f = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _f === void 0 ? void 0 : _f.isLoading;
    var fieldStyle = "flex flex-col mb-2";
    useEffect(function () {
        if (field_defs.length === 0) {
            setMessage("There is no field for mass update");
        }
    }, [field_defs.length]);
    var _j = useState({}), updatedField = _j[0], setUpdatedField = _j[1];
    var updateRecordMutaion = useUpdateRecordsMutation()[0];
    var submission = function (e) { return __awaiter(_this, void 0, void 0, function () {
        var requestData, result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    isLoading(true); // Début du chargement
                    layout.removeWidgetById({
                        id: widget.id,
                        slot: [Slot.MODAL],
                        type: "widget/massupdate",
                    });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 7, 8, 9]);
                    requestData = {
                        moduleName: moduleName,
                        body: {
                            ids: idsrecord,
                            record: updatedField,
                        },
                    };
                    return [4 /*yield*/, updateRecordMutaion(requestData).unwrap()];
                case 2:
                    result = _a.sent();
                    if (!(result.data.update === "ok")) return [3 /*break*/, 5];
                    toast.success("Massupdate done");
                    if (!onSubmit) return [3 /*break*/, 4];
                    return [4 /*yield*/, onSubmit(1)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    isLoading(false);
                    return [3 /*break*/, 6];
                case 5:
                    toast.error("Massupdate failed");
                    isLoading(false);
                    _a.label = 6;
                case 6: return [3 /*break*/, 9];
                case 7:
                    error_1 = _a.sent();
                    toast.error("Massupdate not executed");
                    isLoading(false);
                    return [3 /*break*/, 9];
                case 8:
                    isLoading(false);
                    return [7 /*endfinally*/];
                case 9: return [2 /*return*/];
            }
        });
    }); };
    var onUpdateField = useCallback(function (edited) {
        var key = Object.keys(edited)[0];
        var value = edited[key];
        if (updatedField[key] !== value) {
            setUpdatedField(function (prevUpdatedField) {
                var _a, _b;
                var isKeyExists = Object.prototype.hasOwnProperty.call(prevUpdatedField, key);
                if (isKeyExists) {
                    // Mettre à jour la valeur existante pour la clé donnée
                    return __assign(__assign({}, prevUpdatedField), (_a = {}, _a[key] = value, _a));
                }
                else {
                    // Ajouter la nouvelle clé: valeur si elle n'existe pas déjà
                    return __assign(__assign({}, prevUpdatedField), (_b = {}, _b[key] = value, _b));
                }
            });
        }
    }, [updatedField]);
    return (_jsxs("div", __assign({ className: "flex flex-col max-w-md py-10 mx-auto" }, { children: [_jsx("p", __assign({ className: "mb-3" }, { children: (_g = widget === null || widget === void 0 ? void 0 : widget.payload) === null || _g === void 0 ? void 0 : _g.title })), _jsx("b", __assign({ className: "text-center text-fuchsia-500" }, { children: message })), _jsxs("form", __assign({ onSubmit: submission }, { children: [_jsx("div", __assign({ className: fieldStyle }, { children: field_defs &&
                            Object.keys(field_defs).map(function (key, index) { return (_jsx(_Fragment, { children: _jsx(DisplayField, { record: updatedField, moduleName: moduleName, fieldName: field_defs[key].name, viewType: FieldViewType.EDIT, fieldLabel: field_defs[key].name, fieldMetadata: field_defs[key], separatorIndicator: ":", hideLabel: false, className: "p-1", onUpdate: onUpdateField, labelClassName: "font-medium", showEditButton: false }, index) })); }) })), _jsx("div", { children: field_defs.length > 0 && (_jsx("div", { children: _jsx("button", __assign({ type: "submit", className: "h-10 px-6 mt-2 font-semibold button success" }, { children: "Submit" })) })) })] }))] })));
}
widgetsDictionary.register("widget/massupdate", {
    name: "Formulaire edition",
    display: MassupdateForm,
    selectable: false,
});
